
import Vue, {PropOptions} from 'vue'
import {ChefCardInterface} from "~/components/index/chef-highlight.vue";

export default Vue.extend({
  name: 'ChefDetailCard',
  props: {
    chef: {
      type: Object,
      required: true
    } as PropOptions<ChefCardInterface>,
    showContactButton: {
      type: Boolean,
      required: false,
      default: true,
    }
  },
  data() {
    return {
      isModalOpen: false,
      form: {
        first_name: "",
        last_name: "",
        email: "",
        phone: "",
        message: "",
      },
      loading: false
    }
  },
  methods: {
    submitQuestion: async function () {
      this.loading = true;

      await this.$axios.$post(`/v1/chef/${this.chef.id}/question`, {
        booker: {
          first_name: this.form.first_name,
          last_name: this.form.last_name,
          email: this.form.email,
          phone: this.form.phone,
        },
        message: this.form.message,
        path: window.document.URL
      }).catch(error => {
        if (error.response) {
          console.log(error.response)
        }

        let errorMessage = 'Er is een onverwachte fout opgetreden. Controleer het formulier en probeer het opnieuw.';
        if (error.response?.data?.errors.hasOwnProperty('booker.email')) {
          errorMessage = 'Email moet een geldig e-mailadres zijn. Controleer het formulier en probeer het opnieuw.';
        }

        alert(errorMessage);
        return;
      }).finally(() => {
        this.loading = false;
      });

      // Reset
      this.form = {
        first_name: '',
        last_name: '',
        email: '',
        phone: '',
        message: '',
      };

      // Close
      this.isModalOpen = false;

      // Show after model is closed
      setTimeout(() => {
        window.alert('Bedankt voor je vraag. Wij nemen binnen 24 uur contact met je op.');
      }, 100);
    }
  }
})
